// extracted by mini-css-extract-plugin
module.exports = {"main":"HomePage_main__yVDb_","container":"HomePage_container__gdJMm"};